/** @file Resolves an animation by name or id to its id and its mutable record in a command draft. */
import type { Draft } from 'immer';
import type { AnimationDoc, Doc, Id } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';
import type { CommandContext } from '../commandContext';

/** `{ id, anim }` of animation `ref` (name or id); NOT_FOUND with kind `animation` when it does not exist. */
export function animationDraft(draft: Draft<Doc>, ref: string, ctx: CommandContext): { id: Id; anim: Draft<AnimationDoc> } {
  const id = ctx.resolve('animation', ref);
  return { id, anim: draft.animations[id] ?? throwError('NOT_FOUND', { kind: 'animation', ref: id }) };
}
